export const languageConsts = {
    GET_LANGUAGES: "GET_LANGUAGES",
    NEW_LANGUAGE: "NEW_LANGUAGE",
    UPDATE_LANGUAGE: "UPDATE_LANGUAGE",
    DELETE_LANGUAGE: "DELETE_LANGUAGE",
};